import { render, staticRenderFns } from "./KnowledgePoints.vue?vue&type=template&id=8198ca30&scoped=true&"
import script from "./KnowledgePoints.vue?vue&type=script&lang=js&"
export * from "./KnowledgePoints.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgePoints.vue?vue&type=style&index=0&id=8198ca30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8198ca30",
  null
  
)

export default component.exports